import React, { useEffect, useState } from "react";
import Input from "./Inputs/Input";
import { proxyAPI } from "../../../proxyAPI";

interface KeyInputProps {
  value: string;
  onChange: (value: string) => void;
  isSummary?: boolean;
  label?: string;
}

export default function KeyInput({ value, onChange, isSummary, label }: KeyInputProps) {
  const [inputValue, setValue] = useState<string>(value);
  const [debounceTimer, setdebounceTimer] = useState<NodeJS.Timeout | null>(null);
  const [inputHelp, setInputHelp] = useState<string>("");

  useEffect(() => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    if (inputValue) {
      setInputHelp("Validating...");
      setdebounceTimer(
        setTimeout(async () => {
          const data = await proxyAPI({
            prefix: "logic/workflows/api",
            url: `/validate-json-path?path=${inputValue}`,
            setLoading: () => null,
          });
          setInputHelp(data.message);
        }, 1000)
      );
    } else {
      setInputHelp("");
    }
    onChange(inputValue);

    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [inputValue]);

  return (
    <Input
      label={label}
      isSummary={isSummary}
      inputHelp={
        <>
          Enter JSON Key:
          <br />
          {inputHelp}
        </>
      }
      value={[inputValue]}
      onChange={(values) => {
        setValue(values[0]);
      }}
    />
  );
}
